/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */

export enum ILabelColor {
    color0 = 'color0',
    color1 = 'color1',
    color2 = 'color2',
    color3 = 'color3',
    color4 = 'color4',
    color5 = 'color5',
    color6 = 'color6',
    color7 = 'color7',
    color8 = 'color8',
    color9 = 'color9',
    color10 = 'color10',
    color11 = 'color11',
    color12 = 'color12',
    color13 = 'color13',
    color14 = 'color14',
    color15 = 'color15',
    color16 = 'color16',
    color17 = 'color17',
    color18 = 'color18',
    color19 = 'color19',
    color20 = 'color20',
    color21 = 'color21',
    color22 = 'color22',
    color23 = 'color23',
    color24 = 'color24',
}

export const LabelColor  = {
    [ILabelColor.color0]: '#ffffff',
    [ILabelColor.color1]: '#24A33C',
    [ILabelColor.color2]: '#FAEC4A',
    [ILabelColor.color3]: '#EF5E30',
    [ILabelColor.color4]: '#E53559',
    [ILabelColor.color5]: '#5F3588',
    [ILabelColor.color6]: '#2590B3',
    [ILabelColor.color7]: '#5C7422',
    [ILabelColor.color8]: '#955B26',
    [ILabelColor.color9]: '#86271D',
    [ILabelColor.color10]: '#722353',
    [ILabelColor.color11]: '#2D2858',
    [ILabelColor.color12]: '#146A62',
    [ILabelColor.color13]: '#9BBF37',
    [ILabelColor.color14]: '#FB9237',
    [ILabelColor.color15]: '#E82E29',
    [ILabelColor.color16]: '#BE3794',
    [ILabelColor.color17]: '#422FB1',
    [ILabelColor.color18]: '#00AAA2',
    [ILabelColor.color19]: '#12642B',
    [ILabelColor.color20]: '#9F9233',
    [ILabelColor.color21]: '#8A3F22',
    [ILabelColor.color22]: '#862335',
    [ILabelColor.color23]: '#371C4C',
    [ILabelColor.color24]: '#135679',
}
